import { makeStringDataField } from './DataFieldHelper';
import { DataField } from './DataField';

/**
 * Add a metadata field to the list of data fields indicating that a specific contract has been used.
 * For example, we might add the data field zC.MySdx: Office.System.SDX, which indicates that
 * the fields under MySdx conform to the Office.System.SDX contract.
 * @param dataFields - The list of data fields, to which a contract field will be added
 * @param instanceName - The instance of the contract. Usually the same as the contract name without its namespace,
 *                       but can be different, especially if you have more than one of the same contract type in a single event.
 * @param contractName - The name of the contract, for example Office.System.SDX
 */
export function addContractField(dataFields: DataField[], instanceName: string, contractName: string): void {
  dataFields.push(makeStringDataField(`zC.${instanceName}`, contractName));
}
